import { connect } from 'react-redux';

import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react'

import {
    setNextPreviewsInfo,
} from '../redux/actions/dataActions';

import { getAnalytics, logEvent } from "firebase/analytics";

import axios from 'axios';

import useWindowDimensions from '../components/windowHelper';
import { loadTrack } from '../components/audioHelper';
import { PlayArrowRounded } from '@mui/icons-material';
import { ACCENT_COLOR } from '../constants/colors';

import Loading from '../components/Loading';

import TopicSpeakerPreviews from '../components/TopicSpeakerPreviews';
import TopBar from '../components/TopBar';


const Topic = ({
    authenticated,
    setNextPreviewsInfo,
}) => {
    const navigate = useNavigate();
    let params = useParams();
    const analytics = getAnalytics();

    useEffect(() => {
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'topic'
        });
    }, [analytics]);

    const [topic, setTopic] = useState(null);
    const [loading, setLoading] = useState(true);

    const { width } = useWindowDimensions();

    useEffect(() => {
        document.getElementById('audio').pause();
        if (!!params.topicId) {
            setLoading(true);
            axios
                .get(`/topic_previews/${params.topicId}`)
                .then((res) => {
                    setLoading(false);
                    const data = res.data;
                    setTopic(data);
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                });
        } else {
            setLoading(false);
        }
    }, [params, setTopic, setLoading]);

    const playSuggestion = (suggestion, previewId) => () => {
        if (previewId) {
            const newPreviews = [];
            for (let i = 0; i < suggestion.previews.length; i++) {
                const preview = suggestion.previews[i];
                if (preview.id === previewId) {
                    newPreviews.push(preview);
                    for (let j = 0; j < suggestion.previews.length; j++) {
                        if (j !== i) {
                            newPreviews.push(suggestion.previews[j])
                        }
                    }
                    break;
                }
            }
            suggestion.previews = newPreviews;
        }
        loadTrack(suggestion.previews[0].mp3URL, 0);
        setNextPreviewsInfo(authenticated, suggestion.previews, { playbackTopic: suggestion.id });
        navigate('/previews', { state: { title: suggestion.id } });
    }

    return (
        <div>
            <div className="container">
                <div className='animate__animated animate__fadeIn'>
                    {loading ?
                        <Loading />
                        :
                        <div style={{ background: 'var(--app-background)' }}>
                            {!!topic ?
                                <div>
                                    <TopBar />
                                    <div style={{ padding: '0px 20px' }}>
                                        <div className='heading' style={{ padding: '10px 0px 30px' }}>
                                            {topic.id}
                                        </div>
                                        <div style={{ paddingBottom: 'calc(106px + env(safe-area-inset-bottom))' }}>
                                            <TopicSpeakerPreviews
                                                hideTopic={true}
                                                playTopic={playSuggestion}
                                                showAll={true}
                                                overrideSpeakersPerRow={width > 420 ? 4 : 3}
                                                topic={topic}
                                            />
                                        </div>
                                    </div>
                                    <div className='playPreviewsFooter'>
                                        <div className='horizontalCenter'>
                                            <div style={{ textAlign: 'center', margin: '20px' }}>
                                                <button style={{ background: 'var(--app-action)', color: 'var(--app-action-ink)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', padding: '10px', width: '100%', borderRadius: '40px' }} onClick={playSuggestion(topic)}>
                                                    <div style={{ fontWeight: '500', fontSize: '18px' }}>
                                                        <PlayArrowRounded style={{ fontSize: '30px', verticalAlign: 'middle' }} />
                                                        <span style={{ verticalAlign: 'middle', margin: '0px 16px 0px 10px' }}>
                                                            Highlights
                                                        </span>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>
                                    <TopBar />
                                    <div className='center' style={{ textAlign: 'left', width: '100%', maxWidth: 'var(--app-max-width)', padding: '0px 20px' }}>
                                        <div className='heading'>{params.topicId}</div>
                                        <div className='subheading'>No show previews found</div>
                                        <div className='subheading' style={{ padding: '30px 0px' }}>We're adding more shows daily. Please check back soon!</div>
                                        <div>
                                            <a style={{ color: ACCENT_COLOR, fontWeight: '500', fontSize: '16px' }} href='/search'>
                                                Search for something else
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
})

const mapActionsToProps = {
    setNextPreviewsInfo,
}

export default connect(mapStateToProps, mapActionsToProps)(Topic);
